const autoGameStateSet = new Set(['','play', 'video']);

const getGameTab = (game_state, game_tab) => {
    switch (game_state) {
        case 'play':
            return '';
        case 'video':
            return game_state;
        default:
            return game_tab;
    }
};

const getGameDetail = (game_state, game_tab, detail) => {
    switch (game_state) {
        case 'video':
            return game_tab || '';
        default:
            return detail;
    }
};


export {
    autoGameStateSet,
    getGameTab,
    getGameDetail
}